import { css } from 'aphrodite';
import * as React from 'react';
import { useState } from 'react';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { QuickSightDashboardViewModel } from '../../../viewmodels/AdminViewModels';
import { Select, SelectContent, SelectItem, SelectTrigger } from '../../../web/components-v2/Select';
import { Report } from '../../components/Report';
import { BasicPage } from '../BasicPage';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
}

interface IDashboard {
	id: string;
	text: string;
}

const realMagicSettingsCards: IDashboard[] = [
	{
		id: QuickSightDashboardViewModel.AIDARealMagicDialsId,
		text: 'Dials',
	},
	{
		id: QuickSightDashboardViewModel.AIDARealMagicProspectingKPIsId,
		text: 'Prospecting KPIs',
	},
	{
		id: QuickSightDashboardViewModel.AIDARealMagicCloserKPIsId,
		text: 'Closer KPIs',
	},
	{
		id: QuickSightDashboardViewModel.AIDARealMagicBookedByOverviewId,
		text: 'Booked by Overview',
	},
	{
		id: QuickSightDashboardViewModel.AIDARealMagicDemoQualityId,
		text: 'Demo Quality',
	},
	{
		id: QuickSightDashboardViewModel.AIDARealMagicCircleOfMagicId,
		text: 'Circle of Magic',
	},
	{
		id: QuickSightDashboardViewModel.AIDARealMagicAugustEOMId,
		text: 'August EOM',
	},
];

const customerSettingsCards: IDashboard[] = [
	{
		id: QuickSightDashboardViewModel.AIDACustomersDialsId,
		text: 'Dials',
	},
];

export const ReportingContainer: React.FC<IProps> = ({ className = '' }) => {
	const userSession = useUserSession();

	const [dashboardId, setDashboardId] = useState<string>();

	const [dashboardIds, setDashboardIds] = useState<IDashboard[]>();

	React.useEffect(() => {
		const valid = userSession.account.isLevitateSalesCoffeeAccount ? realMagicSettingsCards : customerSettingsCards;
		setDashboardIds(valid);
		setDashboardId(valid[0].id);
	}, [userSession.account.isLevitateSalesCoffeeAccount]);

	const picker =
		dashboardIds && dashboardIds.length > 0 && dashboardId ? (
			<div className={css(styleSheet.selectRow)}>
				<Select value={dashboardId} onValueChange={setDashboardId}>
					<SelectTrigger aria-label='Dashboard' styles={styleSheet.selectTrigger}>
						{dashboardIds.find(d => d.id === dashboardId)?.text ?? 'Select a dashboard'}
					</SelectTrigger>
					<SelectContent styles={styleSheet.selectContent}>
						{dashboardIds.map(dashboard => (
							<SelectItem key={dashboard.id} value={dashboard.id}>
								{dashboard.text}
							</SelectItem>
						))}
					</SelectContent>
				</Select>
			</div>
		) : null;

	return (
		<BasicPage appearance='light' className={className} headerActions={picker} title='Reporting'>
			<div className={css(styleSheet.content)}>
				{dashboardId && <Report key={dashboardId} dashboardId={dashboardId} />}
			</div>
		</BasicPage>
	);
};
